import type { Error } from '../types';

export const notEqualTo = (compareTo: string, message?: Error['message']) => (value: string) => ({
  valid: compareTo !== value,
  message
});
